import React from 'react';
import PropTypes from 'prop-types';
import Company from 'src/components/ApplyTo/Company';
import Offers from 'src/components/ApplyTo/Offers';
import 'src/components/ApplyTo/ApplyTo.scss';


const ApplyTo = ({ employers }) => employers.map(({
  employerName,
  employerId,
  employerLogos,
  offersCount,
  allOffersUrl,
  employerProfileUrl,
  offers
}, index) => (
  <div
    key={ `${employerProfileUrl + index}` }
    data-test="section-applyToCompanyTile"
    styleName="apply-to"
  >
    <Company
      employerId={ employerId }
      index={ index }
      isSingle={ offers.length === 0 }
      logos={ employerLogos }
      name={ employerName }
      profileUrl={ employerProfileUrl }
    />
    { offers.length > 0
        && (
        <Offers
          allOffersUrl={ allOffersUrl }
          employerId={ employerId }
          employerName={ employerName }
          index={ index }
          list={ offers }
          offersCount={ offersCount }
        />
        )
      }
  </div>
));
ApplyTo.propTypes = {
  employers: PropTypes.arrayOf(PropTypes.shape({
    allOffersUrl: PropTypes.string.isRequired,
    employerId: PropTypes.number.isRequired,
    employerLogos: PropTypes.object.isRequired,
    employerName: PropTypes.string.isRequired,
    employerProfileUrl: PropTypes.string.isRequired,
    offers: PropTypes.array,
    offersCount: PropTypes.number.isRequired
  })).isRequired
};

export default ApplyTo;
